import SEO from "@/components/SEO";
import { PageHero } from "@/pages/ServicesPage";
import { IMAGES } from "@/data/content";

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page">
      <SEO
        title="Privacy Policy | Estate Outdoors Calgary"
        description="How Estate Outdoors Calgary collects, uses and protects your personal information when you request a quote or apply as a contractor."
      />
      <PageHero testid="privacy-hero" eyebrow="Privacy" title="Privacy Policy" image={IMAGES.hero} />
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 space-y-8 text-base leading-relaxed text-[#4A524C]">
          <p><em className="text-[#758077] text-sm">Last updated: July 2026</em></p>
          <h2 className="font-display text-2xl font-normal text-[#1C201D]">What We Collect</h2>
          <p>
            When you request a quote or submit a contractor application, we collect the details you provide: your
            name, contact information, property information, project description, and any photos or plans you
            choose to upload.
          </p>
          <h2 className="font-display text-2xl font-normal text-[#1C201D]">How We Use It</h2>
          <p>
            Your information is used solely to review your project, contact you about your request, and — with
            your request — introduce you to carefully selected landscape designers, contractors or trades suited
            to your project. We do not sell or rent your personal information.
          </p>
          <h2 className="font-display text-2xl font-normal text-[#1C201D]">Storage & Security</h2>
          <p>
            Submissions are stored securely and accessible only to our team. Uploaded files are stored in encrypted
            cloud storage and viewed only in connection with your project.
          </p>
          <h2 className="font-display text-2xl font-normal text-[#1C201D]">Analytics</h2>
          <p>
            We may use privacy-respecting analytics (such as Google Analytics) to understand how visitors use this
            site. No form details are shared with analytics providers.
          </p>
          <h2 className="font-display text-2xl font-normal text-[#1C201D]">Your Choices</h2>
          <p>
            You may ask us to update or delete your information at any time by emailing
            <a href="mailto:springbankluxurylandscapes@gmail.com" className="text-[#8B5A2B] hover:text-[#C5A059]"> springbankluxurylandscapes@gmail.com</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
